<!-- eslint-disable vue/multi-word-component-names -->

<template>
  <div class="row q-col-gutter-md">
    <div class="col-12 col-md-6">
      <GlassCard class="q-pa-xs">
        <CampusPlusLogo size="64" style="float: right; margin-right: -10px; margin-left: 10px; margin-top: -10px" />
        <h1 class="q-mb-md">{{ $t("portal.start.welcome.heading") }}</h1>
        <p class="q-mb-sm">
          {{ $t("portal.start.welcome.body") }}
        </p>

        <div class="q-mt-lg q-mb-none">
          <h5>{{ $t("portal.start.labels.newsletter") }}:</h5>
          <i18n-t keypath="portal.start.newsletter.body" tag="p" scope="global"><a
              href="https://www.lists.kit.edu/sympa/subscribe/campusplus">{{ $t("portal.start.newsletter.name")
              }}</a></i18n-t>
        </div>

        <q-btn :icon="symOutlinedImportContacts" size="md" no-caps color="blue" class="q-mb-md"
          :to="{ name: 'SMUProceduresList' }">&nbsp;{{ $t("portal.gotosignmeup") }}</q-btn>

        <p v-if="!isLoggedIn">
          {{ $t("portal.start.login.requiredText") }}<br />
          <q-btn color="teal" href="/api/user/oidc-login" class="q-mt-sm q-mr-sm" :icon="symOutlinedLogin"
            :label="t('portal.start.login.loginKIT')"></q-btn>
          <q-btn color="purple" :to="{ name: 'Login' }" class="q-mt-sm q-mr-sm" :icon="symOutlinedLogin"
            :label="t('portal.start.login.loginExternal')"></q-btn>
          <q-btn color="indigo" :to="{ name: 'Register' }" class="q-mt-sm" :icon="symOutlinedAppRegistration"
            :label="t('portal.start.login.register')"></q-btn>
        </p>
      </GlassCard>
    </div>
    <div class="col-12 col-md-6">
      <MiniGlassCard caption="Anwenderschulung am 27.03.2025" color="blue" class="q-mb-md">
        Am 27.03. fand eine Schulung für alle Anwender/innen von SignMeUp statt. Vielen Dank für die
        zahlreiche Teilnahme!<br />
        Die Aufzeichnung wird ab 02.04. auf der <a href="https://docs.campus.kit.edu/signmeup/schulung-2025-03-27.html"
          target="_blank" class="text-blue text-bold">Info-Seite zur Schulung</a> zur Verfügung stehen.

      </MiniGlassCard>
      <GlassCard class="q-pa-xs">
        <h2 class="q-mb-sm">{{ $t("common.labels.changes") }}</h2>

        <h5>Version 2.18: SignMeUp: Optimierung mit zulässigen leeren Themen bei Mindestteilnehmerzahl
        </h5>
        <div class="text-caption text-bold" style="--color-highlight-2: #ff0000">
          24.04.2025
        </div>
        <p>
          Bei der Verwendung einer Mindestteilnehmerzahl pro Thema/Termin hat der Optimierungsalgorithmus bisher
          erzwungen, dass in jedem Termin eine entsprechende Anzahl Zuweisungen erfolgt. Dies führte dazu, dass eine
          Optimierung nicht möglich war, wenn die Gesamtzahl der Anmeldung zu gering war. Ab sofort können Sie leere
          Themen erlauben. In dem Fall kann der Algorithmus dann auch entscheiden das jeweilige Thema ganz leer zu
          lassen, wenn die Mindestzahl nicht sinnvoll erreicht werden kann.
        </p>

        <h5>Version 2.17: SignMeUp: Themen-Assistent
        </h5>
        <div class="text-caption text-bold" style="--color-highlight-2: #ff0000">
          17.03.2025
        </div>
        <p>
          Zum Anlegen von Themen gibt es nun auch einen Themen-Assistenten, der eine Vielzahl von Themen mit dem
          gleichen Namensmuster (z.B. "Gruppe #1", "Gruppe #2", ...) anlegen kann. Sie haben dabei die Wahl zwischen
          verschiedenen Zahlendarstellungen.
        </p>

        <h5>Version 2.16: SignMeUp: Gebührenverwaltung, Themenwahl mit Genehmigung, Personeneintrag als Thema und
          Kontrollmails. BZM+: Ausweisung Anzahl Halbjahre Fremdsprache in Export.
        </h5>
        <div class="text-caption text-bold" style="--color-highlight-2: #ff0000">
          07.03.2025
        </div>
        <p>
          Mit diesem größeren Update bringen wir Ihnen mehrere neue Funktionen und Verbesserungen. In SignMeUp gibt es
          jetzt eine grundlegende Gebührenverwaltung, welche es ermöglicht pro Personengruppe eine fällige Gebühr zu
          hinterlegen und den Gebührenstatus zu setzen. Außerdem lassen sich jetzt Anmeldeverfahren mit einer Art
          Genehmigungsprozess über die Themenwahl durchführen. Als neue Themenart steht Ihnen ein reiner
          "Personeneintrag" zur Verfügung und für manuell versendete Nachrichten erhalten Sie automatisch eine
          Kontrollmail, welche auch die Empfängerliste enthält.<br /><br />

          In BZM+ können Sie jetzt die Anzahl der Halbjahre für die in der HZB angegebene Fremdsprache im Export
          ausweisen lassen.
          <br /><br />
          Ausführliche Informationen zu diesen Neuerungen finden Sie in den <a
            href=" https://docs.campus.kit.edu/updates/" target="_blank" class="text-blue text-bold">{{
              $t("portal.start.changes.versinfo")
            }}</a>.
        </p>

        <h5>Version 2.15: SignMeUp: Bearbeiten von Weiteren Angaben und Themenbewertungen bei Anmeldungen
        </h5>
        <div class="text-caption text-bold" style="--color-highlight-2: #ff0000">
          11.02.2025
        </div>
        <p>
          Als Anbieter einer Veranstaltung können Sie nun bestehende Anmeldungen editieren, um die Weiteren Angaben oder
          Themenbewertungen anzupassen (z.B. wenn Sie eine Person manuell angemeldet haben). Der Editierbutton steht am
          Ende der Zeile in der Anmeldungen-Liste wenn Ihr Verfahren Weitere Angaben oder Themen/Termine
          nutzt.<br /><br />
        </p>


        <p class="q-mt-sm">
          {{ $t("portal.start.changes.allchangestext") }}
          <a href=" https://docs.campus.kit.edu/updates/" target="_blank" class="text-blue text-bold">{{
            $t("portal.start.changes.versinfo")
          }}</a>.
        </p>
      </GlassCard>
    </div>
    <!-- <div>
        <q-btn class=" q-ma-xs" color="primary">Primary</q-btn>
              <q-btn class="q-ma-xs" color="secondary">secondary</q-btn>
              <q-btn class="q-ma-xs" color="accent">accent</q-btn>
              <q-btn class="q-ma-xs" color="positive">positive</q-btn>
              <q-btn class="q-ma-xs" color="negative">negative</q-btn>
              <q-btn class="q-ma-xs" color="info">info</q-btn>
              <q-btn class="q-ma-xs" color="warning">warning</q-btn>
              <q-btn class="q-ma-xs" color="main">main</q-btn>
              <q-btn class="q-ma-xs" color="content">content</q-btn>
              <q-btn class="q-ma-xs" color="content-2">content-2</q-btn><br />
              <q-btn class="q-ma-xs" color="pantone-illuminating">pantone-illuminating</q-btn>
              <q-btn class="q-ma-xs" color="pantone-illuminating-complementary">pantone-illuminating-c</q-btn>
              <q-btn class="q-ma-xs" color="pantone-classic-blue">pantone-classic-blue</q-btn>
              <q-btn class="q-ma-xs" color="pantone-classic-blue-complementary">pantone-classic-blue-c</q-btn>
              <q-btn class="q-ma-xs" color="pantone-kingfisher-blue">pantone-kingfisher-blue</q-btn>
              <q-btn class="q-ma-xs" color="pantone-kingfisher-blue-complementary">pantone-kingfisher-blue-c</q-btn>
              <q-btn class="q-ma-xs" color="pantone-very-peri">pantone-very-peri</q-btn>
              <q-btn class="q-ma-xs" color="campus-yellow">campus-yellow</q-btn>
      </div> -->
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import CampusPlusLogo from "@/components/shared/CampusPlusLogo.vue";
import useUserProfile from "@/composables/useUserProfile";
import {
  symOutlinedAppRegistration,
  symOutlinedImportContacts,
  symOutlinedList,
  symOutlinedLogin,
} from "@quasar/extras/material-symbols-outlined";
import { useTitle } from "@vueuse/core";

import GlassCard from "../components/shared/GlassCard.vue";
import MiniCard from "../components/shared/MiniCard.vue";
import MiniGlassCard from "@/components/shared/MiniGlassCard.vue";

const { t } = useI18n();
const { isLoggedIn } = useUserProfile();

useTitle(computed(() => "Campus Plus Portal - " + t("portal.start.welcome.label")));
</script>
